<template>
  <div class="emd-breadcrumb">
    <ol>
      <li class="emd-breadcrumb__item" v-for="(route, index) in routes" :key="`route_${index}`" :class="{'_active' : isActiveRoute(route)}">
          <span v-if="lastItem(index)" class="emd-text _color_default">{{ $t(`${route}.${selectedPaymentType}`) }}</span>
          <span v-else-if="lastItem2(index)" class="emd-text _color_default">{{ $t(`${route}.${selectedPaymentType}`) }} </span>
          <router-link v-else class="emd-text _color_default" :to="{ name: 'OrderType' }">{{ $t(route) }}</router-link>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'EmdBreadcrumb',
  data () {
    return {
      routes: [
        'shop',
        'createOrder',
        'paymentLink'
      ]
    }
  },
  computed: {
    hasSubscriptionEnabled () {
      return this.$store.getters.hasSubscriptionEnabled
    },
    selectedPaymentType () {
      return this.hasSubscriptionEnabled ? this.$store.getters.selectedPaymentType : 'items'
    }
  },
  methods: {
    lastItem (index) {
      return index === this.routes.length - 2
    },
    lastItem2 (index) {
      return index === this.routes.length - 1
    },
    isActiveRoute (route) {
      return (route === 'createOrder' && this.selectedPaymentType !== 'products-services') || (route === 'paymentLink' && this.selectedPaymentType === 'products-services')
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "shop": "Shop",
      "createOrder" : {
        "items": "Criar Pedido",
        "subscription": "Criar Recorrência",
        "products-services": "Criar um pedido",
        "options": "Criar um pedido",
        "typed-sale": "Venda digitada"
      },
      "paymentLink": {
        "items": " ",
        "subscription": " ",
        "products-services": "Link de pagamento",
        "options": " ",
        "typed-sale": " "
      }
    },
    "en-US": {
      "shop": "Shop",
      "createOrder": {
        "items": "Create Order",
        "subscription": "Create Subscription",
        "subscription": "Create Subscription",
        "typed-sale": "Typed Sale"
      },
      "paymentLink": {
        "items": " ",
        "subscription": " ",
        "products-services": "Payment link",
        "options": " ",
        "typed-sale": " "
      }
    }
  }
</i18n>
